
import { Modal } from 'react-bootstrap';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import React from 'react';

export default function JazzCashOnly(props: any) {

    // useEffect(() => {
    //     if (props.show) {
    //         document.body.style.overflow = 'hidden';
    //     } else {
    //         document.body.style.overflow = 'unset';
    //     }
    // }, [props.show]);
    const { t } = useTranslation();
    return (
        <Modal className='track-modal' show={props.show} onHide={props.handleToogle} backdrop={"static"} centered>
            <div className='modal-design'>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <Modal.Header className='justify-content-center' closeButton>
                <Modal.Title><h5>{t("JAZZCASH_TITLE")}</h5></Modal.Title>
            </Modal.Header>
            <Modal.Body className='w-100 delivery-order text-center p-4'>
                <div className='order-options justify-content-center'>
                    <p className='text-center'>
                    {t("JAZZCASH_DESCRIPTION")}
                    </p>
                </div>
            </Modal.Body>
        </Modal>
    )
}
